import React, { useState, useEffect, useRef, useCallback } from "react";
import { withStyles } from "@material-ui/core/styles";
import Dialog from "@material-ui/core/Dialog";
import MuiDialogTitle from "@material-ui/core/DialogTitle";
import MuiDialogContent from "@material-ui/core/DialogContent";
import Typography from "@material-ui/core/Typography";
import IconButton from "@material-ui/core/IconButton";
import HighlightOffIcon from "@material-ui/icons/HighlightOff";
import Webcam from "react-webcam";
import Grid from "@material-ui/core/Grid";
import Camera from '../assets/images/camera.png'
import useWindowDimensions from "./utility";
import MultiButton from "./multiButton";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import AddAPhoto from "@material-ui/icons/AddAPhoto";
import FolderOpenIcon from "@material-ui/icons/FolderOpen";
import imageCompression from 'browser-image-compression';
import { getBase } from "./Functions/imageCompress";

const DialogTitle = withStyles((theme) => ({
  root: {
    borderBottom: `1px solid ${theme.palette.divider}`,
    margin: 0,
    padding: theme.spacing.unit * 2,
    color: "#0A2960",
  },
  closeButton: {
    position: "absolute",
    right: theme.spacing.unit,
    top: theme.spacing.unit,
    color: theme.palette.grey[500],
  },
}))((props) => {
  const { children, classes, onClose } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root}>
      <Typography color="primary" variant="h6">
        {children}
      </Typography>
      {onClose ? (
        <IconButton
          aria-label="Close"
          className={classes.closeButton}
          onClick={onClose}
        >
          <HighlightOffIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});

const DialogContent = withStyles((theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing.unit * 2,
  },
}))(MuiDialogContent);

const styles = (theme) => ({
  captureButton: {
    bottom: "10px",
    placeContent: "center",
  },
  footerButtonView: {
    justifyContent: "center",
    marginTop: 20,
    marginBottom: 20,
  },
  clearButton: {
    height: 60,
    marginRight: 20,
    color: "white",
    padding: 15,
  },
  doneButton: {
    height: 60,
    marginLeft: 20,
    color: "white",
    backgroundColor: "#F29A3E",
    padding: 15,
  },
  errorView: {
    color: "#06336F",
    marginRight: 15,
  },
  paper: { minWidth: 280 },
});

function DialogCamera(props) {
  const {
    classes,
    openDialog,
    updatestate,
    section,
    openWebcam,
    fileUpload = true,
  } = props;
  const [cameraProps, setCameraProps] = useState(props.cameraProps);
  const [getSection, setSection] = useState(section);
  const [isOpen, setOpen] = useState(openDialog);
  const webcamRef = useRef(null);
  const [getImage, setImgSrc] = useState(null);
  const [getBase64, setBase64] = useState(null);
  const [getError, setError] = useState("Something went wrong");
  const [getFileType, setFileType] = useState("IMAGE");
  useEffect(() => {
    setOpen(openDialog);
    if(openWebcam) {
    setSection(2);
    }else {
      setSection(1);
    }
    setFileType("IMAGE");
    setImgSrc(null);
    setBase64(null);
  }, [!openDialog]);

  const { width } = useWindowDimensions();
  const percentage = (30 / 100) * width;

  const imageWidth =
    width < 290 ? 290 : width > 1000 ? 550 : width - percentage;
  const imageHeight = 300;

  const videoConstraints = {
    width: imageWidth,
    height: imageHeight,
    facingMode: "environment" 
  };

  const handleClose = () => {
    setOpen(false);
    updatestate();
  };

  const getBase64___ = file => new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = error => reject(error);
  });
  
  const encodeImage = async (fileArg) => {
      const imageFile = fileArg;
      const options = {
        maxSizeMB: 0.5,
        maxWidthOrHeight: 1000,
        useWebWorker: true
      }
      const compressedFile = await imageCompression(imageFile, options);
      let mainFile = await getBase64___(compressedFile); // write your own logic
      setBase64(mainFile);
  };

  const capture = useCallback(() => {
    try {
      const imageSrc = webcamRef.current.getScreenshot();
      setSection(3);
      fetch(imageSrc)
        .then((res) => res.blob())
        .then((blob) => {
          const file = new File([blob], `image_${new Date().getTime()}.png`, blob);
          setImgSrc(file);
          encodeImage(file);
        });
    } catch (e) {
      setSection(4);
    }
  }, [webcamRef, setImgSrc]);

  const resetImage = () => {
    setImgSrc(null);
    setBase64(null);
    setSection(2);
  };

  const saveImage = () => {
    const data = { base64: getImage, image : getBase64 };
    setOpen(false);
    updatestate(cameraProps, data);
  };

  const throwError = (error) => {
    setError(error);
    setSection(4);
  };

  const handleFile = async (e) => {
    try {
      const { target } = e;
      const fileType = target.files[0].type.includes("pdf") ? "PDF" : "IMAGE";
      setFileType(fileType);
      let compressedFile = await getBase(target.files[0]);
      setImgSrc(compressedFile);
      encodeImage(target.files[0]);
      setSection(3);
    } catch (e) {
      setSection(4);
    }
  };

  const renderContent = (arg) => {
    // eslint-disable-next-line default-case
    switch (arg) {
      case 1:
        return (
          <List component="nav">
            <ListItem button onClick={() => setSection(2)}>
              <ListItemIcon>
                <AddAPhoto />
              </ListItemIcon>
              <ListItemText primary="Take Photo" />
            </ListItem>
            {fileUpload && (
              <ListItem button onChange={handleFile}>
                <ListItemIcon>
                  <FolderOpenIcon />
                </ListItemIcon>
                <input
                  accept="image/jpeg,image/png,application/pdf"
                  className={classes.input}
                  style={{ display: "none" }}
                  id="raised-button-file"
                  type="file"
                />
                <label htmlFor="raised-button-file">
                  <ListItemText primary="Choose from Library" />
                </label>
              </ListItem>
            )}
          </List>
        );
      case 2:
        return (
          <React.Fragment>
            <Grid container xs={12}>
              <Webcam
                onUserMediaError={throwError}
                audio={false}
                ref={webcamRef}
                screenshotFormat="image/jpeg"
                videoConstraints={videoConstraints}
              />
            </Grid>
            <Grid container className={classes.captureButton} xs={12}>
              <IconButton onClick={capture}>
                <img alt="" src={Camera} width="80" height="80" />
              </IconButton>
            </Grid>
          </React.Fragment>
        );
      case 3:
        return (
          <React.Fragment>
            <Grid container xs={12} style={{ justifyContent: "center" }}>
              <img
                alt=""
                src={getFileType === "PDF" ? Camera : getBase64}
                width={getFileType === "PDF" ? 100 : imageWidth}
                height={getFileType === "PDF" ? 100 : imageHeight}
              />
            </Grid>
            <MultiButton resetButton={resetImage} saveButton={saveImage} disableButton={getBase64 ? false : true} />
          </React.Fragment>
        );
      case 4:
        return (
          <Typography variant="subtitle1" className={classes.errorView}>
            {String(getError)}
          </Typography>
        );
    }
  };

  return (
    <div>
      <Dialog
        classes={{ paper: classes.paper }}
        onClose={handleClose}
        aria-labelledby="customized-dialog-title"
        open={isOpen}
      >
        <DialogTitle id="customized-dialog-title" onClose={handleClose}>
          Photo
        </DialogTitle>
        <DialogContent>{renderContent(getSection)}</DialogContent>
      </Dialog>
    </div>
  );
}

export default withStyles(styles)(DialogCamera);
